import React, { useId } from 'react';
import { useTranslation } from 'react-i18next';
import { useController, useFormContext } from 'react-hook-form';
import TagInput from '@wix/da-shared-react/pkg/TagInput';
import { OriginalDeviationFieldName } from '../../types';

interface Props {
  noBottomSpacing?: boolean;
}

const TagsField: React.FC<Props> = ({ noBottomSpacing }) => {
  const { t } = useTranslation();
  const id = useId();
  const { control, errors } = useFormContext();

  const {
    field: { value, onChange },
  } = useController({ name: OriginalDeviationFieldName.TAGS, control });
  const error = errors[OriginalDeviationFieldName.TAGS];

  return (
    <TagInput
      withCopy
      id={id}
      label={t('originalDeviationPopup.form.tags.label')}
      placeholder={t('originalDeviationPopup.form.tags.placeholder')}
      value={value}
      onChange={onChange}
      noBottomSpacing={noBottomSpacing}
      validationResult={error && ('error' as any)}
      details={error?.message}
    />
  );
};
TagsField.displayName = 'TagsField';

export default TagsField;
